import { useState, useEffect } from 'react';
import RestProvider from 'providers/RestProvider';
import {
    Dialog,
    DialogContent,
    Grid,
    AppBar,
    Toolbar,
    makeStyles,
    IconButton,
    Typography,
    CircularProgress
} from '@material-ui/core';
import { objText } from '../bandejaSolicitudes/BandejaSolicitudesData';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
    dialogo: {
        marginLeft: "0px"
    },
    appBar: {
        position: 'relative',
        color: "#fff",
        backgroundColor: "#01843e",
    },
    greyBackground: {
        background: '#f7f7f7',
        padding: '30px'
    },
}));

export const DialogMostrarCredito = (props) => {
    const { open, setOpen, title, datosCredito } = props;
    const classes = useStyles();
    
    const [mensajeTitulo, setMensajeTitulo] = useState('');
    const [loading, setLoading] = useState(false);

    const { crudOperation, crudOperationsType } = RestProvider();

    useEffect(() => {
        if (open) {
            setLoading(true);
            crudOperation(crudOperationsType.CUSTOM, 'resolucion', { url: `/expediente/${datosCredito.idExpediente}`, method: 'get'}).then(response => {
                const resoluciones = response.data;
                let importeTotal = 0;

                if (Array.isArray(resoluciones) && resoluciones.length > 0) {
                    importeTotal = resoluciones.reduce((sum, res) => sum + (res.importeConcedido || 0), 0);
                }
                let mensaje = '';

                if (importeTotal === 0 || importeTotal === null || importeTotal === '' || importeTotal === undefined) {
                    mensaje = objText.TEXT_MOSTRAR_CREDITO.replace("{numeroExpediente}", datosCredito.numeroExpediente);
                } else {
                    mensaje = `${objText.TEXT_MOSTRAR_CREDITO_ASGINADO.replace("{numeroExpediente}", datosCredito.numeroExpediente)} ${importeTotal} €.`;
                }
                setMensajeTitulo(mensaje);

                }).catch(function (error) {
                    console.error("Error al obtener la resolución:", error);
                }).finally(() => {
                    setLoading(false);
                });
        } else {
            setMensajeTitulo('');
        }
    }, [open]);

    return (
        <Dialog
            fullWidth={true}
            className={classes.dialogo}
            maxWidth="md"
            scroll="body"
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit"
                        onClick={() => setOpen(false)} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        {title}
                    </Typography>
                </Toolbar>
            </AppBar>

            <DialogContent className={classes.greyBackground}>
                <Grid container alignItems="center" spacing={2}>
                {loading ? (
                    <Grid item xs={12} container justifyContent="center">
                        <CircularProgress style={{ color: "#01843e" }}/>
                    </Grid>
                ) : (
                    <Typography>{mensajeTitulo}</Typography>
                )}
                </Grid>
            </DialogContent>

        </Dialog>
    );
};
